export class FetchWorkTypeError extends Error {

}
